import React, { FC, HTMLProps, ImgHTMLAttributes } from "react";
import cn from "classnames";
import stl from "./index.module.scss";
import img from "../../assets/images/defaultProductImage.svg";

interface Props extends HTMLProps<HTMLDivElement> {
  square?: boolean;
  imageProps?: ImgHTMLAttributes<HTMLImageElement>;
  contentWrapProp?: HTMLProps<HTMLDivElement>;
}

const DefaultImage: FC<Props> = ({
  square,
  className,
  imageProps,
  contentWrapProp,
  ...props
}) => {
  return (
    <div
      {...props}
      className={cn(className, stl.block, { [stl.square]: square })}
    >
      <div
        {...contentWrapProp}
        className={cn(contentWrapProp?.className, stl.content)}
      >
        <img
          src={img}
          alt=""
          {...imageProps}
          className={cn(imageProps?.className, stl.image)}
        />
      </div>
    </div>
  );
};

export default DefaultImage;
